import DefaultCell from "application/components/DefaultCell";

const operationURLS = {
  list: "/queueTimeInterval/sixtyList",
  pdfDownload: "queueTimeInterval/generateAndDownloadPdf",
  csvDownload: "/queueTimeInterval/sixty/downloadCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Queue Id",
      accessor: "queue",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value}/>,
    },
    {
      Header: "Queue Name",
      accessor: "queueName",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Start Interval",
      accessor: "st",
      displayInList: true,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "End Interval",
      accessor: "et",
      displayInList: true,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Total Call Offered",
      accessor: "callOffered",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Total Call Answered",
      accessor: "answered",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Total Call Abandoned",
      accessor: "noAnswer",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, operationURLS };
